export default __webpack_public_path__ + "66d74b41579bff85b953a99ace15dcfb.pdf";